import { Globals } from '../../modules/Globals';
import axios from 'axios';
import { IUser } from '../../interfaces/IUser';

const apiUrl = Globals.apiPath + '/auth';

export default class AuthService {
  constructor() {}

  async login(email: string, password: string): Promise<IUser> {
    let res = await axios.post<IUser>(`${apiUrl}/signin`, { email, password });
    return res.data;
  }

  async getMe(): Promise<IUser> {
    let res = await axios.get<IUser>(`${apiUrl}/me`);
    return res.data;
  }

  async logout(): Promise<any> {
    let res = await axios.get<any>(`${apiUrl}/logout`);
    return res.data;
  }

  async forgot(email: string) {
    let res = await axios.post<any>(`${apiUrl}/forgot`, { email });
    return res.data;
  }

  async getUserByForgotToken(token: string) {
    let res = await axios.get<any>(
      `${apiUrl}/forgot?token=${encodeURIComponent(token)}`
    );
    return res.data;
  }

  async resetPassword(token: string, password: string) {
    let res = await axios.put<any>(`${apiUrl}/reset`, { token, password });
    return res.data;
  }

  async unsubscribe(token: string) {
    let res = await axios.post<any>(`${apiUrl}/unsubscribe`, { token });
    return res.data;
  }

  async sendVerifyEmail() {
    let res = await axios.post<any>(`${apiUrl}/sendVerify`);
    return res.data;
  }

  async verifyEmail(token: string) {
    let res = await axios.put<any>(`${apiUrl}/verifyEmail`, { token });
    return res.data;
  }

  static async setPin(pin: string) {
    let res = await axios.put<any>(`${apiUrl}/pin`, { pin });
    return res.data;
  }
}
